import { Injectable } from '@angular/core';
import { HttpService } from '../helper/httpService';
import { Constants } from '../helper/constants';
import { Observable } from 'rxjs';
import { ReasonModel } from '../viewmodels/reason.model';
import { UpdateReasons } from '../../../layouts/viewmodels/updateReasons.model';
import { PcnModel } from '../viewmodels/pcn.model';
import { GlobalObservables } from '../../../app.global.observer';

@Injectable()
export class ReasonService {
  private reasonServiceUrl = Constants.serverUrl + 'api/reason/';

  constructor(public http: HttpService) {}

  /** getReason */
  getReasons(pcnNumber: string): Observable<any> {
    return this.http.Get(this.reasonServiceUrl + 'getReasons' + '/' + pcnNumber);
  }

  /** getSelectedReasons */
  getSelectedReasons(pcnNumber: string): Observable<any> {
    return this.http.Get(this.reasonServiceUrl + 'getSelectedReasons' + '/' + pcnNumber);
  }

  /** postReason */
  setReasons(reasonsList) {
    const data = JSON.stringify(reasonsList);
    return this.http.Post(this.reasonServiceUrl + 'postReasons', data);
  }

  /** setLocalReasons */
  setLocalReasons(reasonsList: Array<ReasonModel>): void {
    sessionStorage.setItem('rm_reasons', JSON.stringify(reasonsList));
    // localStorage.setItem("rm_reasons", JSON.stringify(reasonsList));
  }

  /** getLocalPcn */
  getLocalReasons(): Array<ReasonModel> {
    if (JSON.parse(sessionStorage.getItem('rm_reasons')) !== null) {
      return JSON.parse(sessionStorage.getItem('rm_reasons'));
    } else {
      return [];
    }
  }

  /** postUpdateReasons */
  updateReasons(pcnNumber: string, reasonIds: Array<number>): Observable<any> {
    const model = new UpdateReasons();
    model.pcnNumber = pcnNumber;
    model.reasonIds = reasonIds;
    const data = JSON.stringify(model);
    return this.http.Post(this.reasonServiceUrl + 'updateRepItems/', data);
  }

  // /** getReasonSearchSynonyms */
  // getReasonSearchSynonyms(): Observable<any> {
  //   return this.http.Get(
  //     this.reasonServiceUrl + "getReasonSearchSynonyms"
  //   );
  // }

  addReason(reasonId: number, pcnNumber: string): Observable<any> {
    return this.http.Get(this.reasonServiceUrl + 'addRepItem' + '/' + reasonId + '/' + pcnNumber);
  }

  removeReason(reasonId: number, pcnNumber: string): Observable<any> {
    return this.http.Get(
      this.reasonServiceUrl + 'removeRepItem' + '/' + reasonId + '/' + pcnNumber
    );
  }

  getTopContraventionRICs(pcn: string, reasonCount: number): Observable<any> {
    return this.http.Get(
      this.reasonServiceUrl + 'getTopContraventionRICs' + '/' + pcn + '/' + reasonCount
    );
  }

  getMostRecentReasons(pcn: string, reasonCount: number): Observable<any> {
    return this.http.Get(
      this.reasonServiceUrl + 'getMostRecentReasons' + '/' + pcn + '/' + reasonCount
    );
  }

  setReasonMissingCaption(reason) {
    if (reason.id === 1001) {
      reason.caption = 'person';
    } else if (reason.id === 1123) {
      reason.caption = 'medical';
    } else if (reason.id === 1007) {
      reason.caption = 'display item';
    } else if (reason.id === 1008) {
      reason.caption = 'badge';
    } else if (reason.id === 1016) {
      reason.caption = 'permit';
    } else if (reason.id === 229) {
      reason.caption = 'bus lane/moving';
    } else if (reason.id === 1047) {
      reason.caption = 'exempt';
    } else if (reason.id === 1042) {
      reason.caption = 'parked';
    }
    return reason;
  }

  generateReasonsObject(result) {
    const reasonsNewObject = [];

    // generate reasons categories array
    const reasonsCategoryIds = [];
    result.forEach((reason) => {
      reason = this.setReasonMissingCaption(reason);
      if (reason.id === reason.parentId) {
        reasonsCategoryIds.push(reason.id);
        reasonsNewObject.push(reason);
      }
    });

    // generate reasons subcategories array
    const reasonsSubCategoryIds = [];
    const reasonsSubCategoryObj = [];
    result.forEach((reason) => {
      if (reasonsCategoryIds.indexOf(reason.parentId) > -1 && reason.id !== reason.parentId) {
        const categoryIndexId = reasonsCategoryIds.indexOf(reason.parentId);
        reasonsSubCategoryIds.push(reason.id);
        reasonsSubCategoryObj.push(reason);
        if (reasonsNewObject[categoryIndexId]['subcategories'] === undefined) {
          reasonsNewObject[categoryIndexId]['subcategories'] = [];
        }
        if (reasonsNewObject[categoryIndexId]['subcategoriesList'] === undefined) {
          reasonsNewObject[categoryIndexId]['subcategoriesList'] = [];
        }

        // setting caption string
        if (reason.caption !== '') {
          if (reason.caption.indexOf(',') > -1) {
            const caption = reason.caption.split(',');
            if (reasonsNewObject[categoryIndexId].caption === '') {
              reasonsNewObject[categoryIndexId].caption = caption[0];
            }
            reason.caption = caption[1].substr(1);
          }
        }
        reasonsNewObject[categoryIndexId]['subcategories'].push(reason);
        reasonsNewObject[categoryIndexId]['subcategoriesList'].push(reason.id);
      }
    });

    const reasonsSubCategory2Ids = [];
    const reasonsSubCategory2Obj = [];
    // generating reasons subcategories2 array
    result.forEach((reason) => {
      if (reasonsSubCategoryIds.indexOf(reason.parentId) > -1) {
        reasonsSubCategory2Ids.push(reason.id);
        reasonsSubCategory2Obj.push(reason);
        const subCategoryIndexId = reasonsSubCategoryIds.indexOf(reason.parentId);
        const subCategory = reasonsSubCategoryObj[subCategoryIndexId];
        const categoryIndexId = reasonsCategoryIds.indexOf(subCategory.parentId);
        const subCategoryIndex = reasonsNewObject[categoryIndexId]['subcategoriesList'].indexOf(
          reason.parentId
        );

        if (
          reasonsNewObject[categoryIndexId]['subcategories'][subCategoryIndex]['subcategories'] ===
          undefined
        ) {
          reasonsNewObject[categoryIndexId]['subcategories'][subCategoryIndex]['subcategories'] =
            [];
          reasonsNewObject[categoryIndexId]['subcategories'][subCategoryIndex][
            'subcategoriesList'
          ] = [];
        }

        // setting caption string
        if (reason.caption !== '') {
          if (reason.caption.indexOf(',') > -1) {
            const caption = reason.caption.split(',');
            if (
              reasonsNewObject[categoryIndexId]['subcategories'][subCategoryIndex].caption === ''
            ) {
              reasonsNewObject[categoryIndexId]['subcategories'][subCategoryIndex].caption =
                caption[0];
            }
            reason.caption = caption[1].substr(1);
          }
        }
        reasonsNewObject[categoryIndexId]['subcategories'][subCategoryIndex]['subcategories'].push(
          reason
        );
        reasonsNewObject[categoryIndexId]['subcategories'][subCategoryIndex][
          'subcategoriesList'
        ].push(reason.id);
      }
    });

    const reasonsSubCategory3Ids = [];
    // generating reasons subcategories3 array
    result.forEach((reason) => {
      if (reasonsSubCategory2Ids.indexOf(reason.parentId) > -1) {
        const subCategory2IndexId = reasonsSubCategory2Ids.indexOf(reason.parentId);
        const subCategory2 = reasonsSubCategory2Obj[subCategory2IndexId];
        const subCategoryIndexId = reasonsSubCategoryIds.indexOf(subCategory2.parentId);
        const subCategory = reasonsSubCategoryObj[subCategoryIndexId];
        const categoryIndexId = reasonsCategoryIds.indexOf(subCategory.parentId);
        const subCategoryIndex = reasonsNewObject[categoryIndexId]['subcategoriesList'].indexOf(
          subCategory.id
        );
        const subCategory2Index = reasonsNewObject[categoryIndexId]['subcategories'][
          subCategoryIndex
        ]['subcategoriesList'].indexOf(subCategory2.id);

        reasonsSubCategory3Ids.push(reason.id);
        if (
          reasonsNewObject[categoryIndexId]['subcategories'][subCategoryIndex]['subcategories'][
            subCategory2Index
          ]['subcategories'] === undefined
        ) {
          reasonsNewObject[categoryIndexId]['subcategories'][subCategoryIndex]['subcategories'][
            subCategory2Index
          ]['subcategories'] = [];
          reasonsNewObject[categoryIndexId]['subcategories'][subCategoryIndex]['subcategories'][
            subCategory2Index
          ]['subcategoriesList'] = [];
        }

        // setting caption string
        if (reason.caption !== '') {
          if (reason.caption.indexOf(',') > -1) {
            const caption = reason.caption.split(',');
            if (
              reasonsNewObject[categoryIndexId]['subcategories'][subCategoryIndex]['subcategories'][
                subCategory2Index
              ].caption === ''
            ) {
              reasonsNewObject[categoryIndexId]['subcategories'][subCategoryIndex]['subcategories'][
                subCategory2Index
              ].caption = caption[0];
            }
            reason.caption = caption[1].substr(1);
          }
        }
        reasonsNewObject[categoryIndexId]['subcategories'][subCategoryIndex]['subcategories'][
          subCategory2Index
        ]['subcategories'].push(reason);
        reasonsNewObject[categoryIndexId]['subcategories'][subCategoryIndex]['subcategories'][
          subCategory2Index
        ]['subcategoriesList'].push(reason.id);
      }
    });

    return reasonsNewObject;
  }

  generateReasonsListFromGeneralReasons(reasonsUnformatted, reasonsParentList) {
    const reasonsCategoryIds = [];
    reasonsParentList.forEach((reason) => {
      reasonsCategoryIds.push(reason.id);
    });

    const finalReasonsList = [];
    reasonsUnformatted.forEach((reasonUnformatted) => {
      if (reasonUnformatted.caption.indexOf(',') > -1) {
        const captionReason = reasonUnformatted.caption.split(',');
        reasonUnformatted.caption = captionReason[1];
      }

      let reasonFormatted = {};
      if (reasonsCategoryIds.indexOf(reasonUnformatted.topLevelId) > -1) {
        const indexCat = reasonsCategoryIds.indexOf(reasonUnformatted.topLevelId);
        reasonFormatted = {
          id: reasonUnformatted.id,
          text: reasonUnformatted.caption,
          additional: reasonsParentList[indexCat].name,
          synonyms: reasonUnformatted.synonyms,
        };
        finalReasonsList.push(reasonFormatted);
      }
    });
    return finalReasonsList;
  }

  createReasonToList(reasonsObject) {
    const reasonsList = [];
    reasonsObject.forEach((catObject) => {
      const category = catObject.caption;
      catObject.subcategories.forEach((subcatObject) => {
        if (subcatObject.subcategories === undefined) {
          if (this.setReasonToList(reasonsList, subcatObject, category)) {
            reasonsList.push(this.setReasonToList(reasonsList, subcatObject, category));
          }
        } else {
          subcatObject.subcategories.forEach((subcatObject2) => {
            if (subcatObject2.subcategories === undefined) {
              if (this.setReasonToList(reasonsList, subcatObject2, category)) {
                reasonsList.push(this.setReasonToList(reasonsList, subcatObject2, category));
              }
            } else {
              subcatObject2.subcategories.forEach((subcatObject3) => {
                if (this.setReasonToList(reasonsList, subcatObject3, category)) {
                  reasonsList.push(this.setReasonToList(reasonsList, subcatObject3, category));
                }
              });
            }
          });
        }
      });
    });
    return reasonsList;
  }

  setReasonToList(reasonsList, reason, category) {
    if (!reason.isPermitted) {
      return;
    }
    const reasonElement = {
      id: String(reason.id),
      text: reason.caption,
      value: String(reason.id),
      label: reason.caption, // <strong>in ${category}</strong>`,
      additional: category,
      synonyms: reason.synonyms,
      tooltip: reason.tooltip,
    };
    return reasonElement;
  }

  select2Match(query: any, response: any) {
    if (typeof query.term === 'undefined') {
      return response;
    }
    if (response.text.toUpperCase().indexOf(query.term.toUpperCase()) > -1) {
      return response;
    }
    if (response.synonyms !== undefined) {
      let matchSynonym = false;
      response.synonyms.forEach((synonym) => {
        if (synonym.toUpperCase().indexOf(query.term.toUpperCase()) === 0) {
          matchSynonym = true;
        }
      });
      if (matchSynonym) {
        return response;
      }
    }
    return null;
  }

  //   isReasonsLocked(): boolean {
  //     if (localStorage.getItem("rm_reasons_locked")) {
  //       return JSON.parse(localStorage.getItem("rm_reasons_locked"));
  //     }
  //     return false;
  //   }

  // lockReasons(lock: boolean): void{
  //     localStorage.setItem("rm_reasons_locked", JSON.stringify(lock));
  // }
}
